<template>
  <grids
    v-validate="'required'"
    :title="label"
    :value.sync="formModel.heirsData"
    :root-form-model="{ ...formModel, ...rootFormModel }"
    :config="dataGridConfig"
    :view-mode="viewMode"
    :error-message="errors.first(label)"
    field-properties='{"isNumeric": true}'
  ></grids>
</template>

<script>
import { prepareDynamicFormFieldsForAPI } from '@/modules/global/helpers/utils';
import Grids from '@/components/shared/grids';

export const RELATIONSHIP_DATA_SOURCE = [
  { key: 1, id: 1, value: 'أبيه', name: 'أبيه' },
  { key: 2, id: 2, value: 'ابنه', name: 'ابنه' },
  { key: 3, id: 3, value: 'ابنته', name: 'ابنته' },
  { key: 4, id: 4, value: 'خاله', name: 'خاله' },
  { key: 5, id: 5, value: 'أخوه', name: 'أخوه' },
  { key: 7, id: 7, value: 'أمه', name: 'أمه' },
  { key: 8, id: 8, value: 'أخته', name: 'أخته' },
  { key: 9, id: 9, value: 'زوجته', name: 'زوجته' },
  { key: 10, id: 10, value: 'زوجته السابقة', name: 'زوجته السابقة' },
  { key: 11, id: 11, value: 'عمه', name: 'عمه' },
  { key: 12, id: 12, value: 'ابن ابن عمه', name: 'ابن ابن عمه' },
  { key: 13, id: 13, value: 'جد جده', name: 'جد جده' },
  { key: 14, id: 14, value: 'ابن خاله', name: 'ابن خاله' },
  { key: 15, id: 15, value: 'ابن خالته', name: 'ابن خالته' },
  { key: 16, id: 16, value: 'ابن جدته', name: 'ابن جدته' },
  { key: 17, id: 17, value: 'ابن عمه', name: 'ابن عمه' },
  { key: 18, id: 18, value: 'أخيه الشقيق', name: 'أخيه الشقيق' },
  { key: 19, id: 19, value: 'أخته الشقيقة', name: 'أخته الشقيقة' },
  { key: 20, id: 20, value: 'ابن أخوه', name: 'ابن أخوه' },
  { key: 21, id: 21, value: 'زوجة أبيه', name: 'زوجة أبيه' },
  { key: 22, id: 22, value: 'خالته', name: 'خالته' },
  { key: 23, id: 23, value: 'أبو أبيه', name: 'أبو أبيه' },
  { key: 24, id: 24, value: 'بنت ابنه', name: 'بنت ابنه' },
  { key: 25, id: 25, value: 'ابن ابنه', name: 'ابن ابنه' },
  { key: 26, id: 26, value: 'أم أبيه', name: 'أم أبيه' },
  { key: 27, id: 27, value: 'أم أمه', name: 'أم أمه' },
  { key: 28, id: 28, value: 'أم جده', name: 'أم جده' },
  { key: 29, id: 29, value: 'أخيه لأبيه', name: 'أخيه لأبيه' },
  { key: 30, id: 30, value: 'أخيه لأم', name: 'أخيه لأم' },
  { key: 31, id: 31, value: 'ابن أخيه لأبيه', name: 'ابن أخيه لأبيه' },
  { key: 32, id: 32, value: 'ابن أخيه لأمه', name: 'ابن أخيه لأمه' },
  { key: 33, id: 33, value: 'ابن الأخ الشقيق', name: 'ابن الأخ الشقيق' },
  { key: 34, id: 34, value: 'عمه الشقيق', name: 'عمه الشقيق' },
  { key: 35, id: 35, value: 'ابن عمه', name: 'ابن عمه' },
  { key: 36, id: 36, value: 'ابن عمه الشقيق', name: 'ابن عمه الشقيق' },
  { key: 37, id: 37, value: 'أبو أمه', name: 'أبو أمه' },
  { key: 38, id: 38, value: 'عمته', name: 'عمته' },
  { key: 39, id: 39, value: 'ابن ابنته', name: 'ابن ابنته' },
  { key: 40, id: 40, value: 'بنت ابنته', name: 'بنت ابنته' },
  { key: 41, id: 41, value: 'بنت أخيه الشقيق', name: 'بنت أخيه الشقيق' },
  { key: 42, id: 42, value: 'بنت أخيه', name: 'بنت أخيه' },
  { key: 43, id: 43, value: 'بنت أخيه لأمه', name: 'بنت أخيه لأمه' },
  { key: 44, id: 44, value: 'ابن أخيه لأمه', name: 'ابن أخيه لأمه' },
  { key: 45, id: 45, value: 'ابن أخته الشقيقة', name: 'ابن أخته الشقيقة' },
  { key: 46, id: 46, value: 'عم أمه', name: 'عم أمه' },
  { key: 47, id: 47, value: 'ابن عمه لأمه', name: 'ابن عمه لأمه' },
  { key: 48, id: 48, value: 'ابنة عمه لأمه', name: 'ابنة عمه لأمه' },
  { key: 50, id: 50, value: 'أخته لأبيه', name: 'أخته لأبيه' },
  { key: 51, id: 51, value: 'ابنة خاله', name: 'ابنة خاله' },
  { key: 52, id: 52, value: 'ابنة أخته الشقيقة', name: 'ابنة أخته الشقيقة' },
  { key: 53, id: 53, value: 'ابن بنت أخته الشقيقة', name: 'ابن بنت أخته الشقيقة' },
  { key: 54, id: 54, value: 'ابنة بنت أخته الشقيقة', name: 'ابنة بنت أخته الشقيقة' },
  { key: 55, id: 55, value: 'ابنة بنت أخته', name: 'ابنة بنت أخته' },
  { key: 56, id: 56, value: 'ابن أخته', name: 'ابن أخته' },
  { key: 57, id: 57, value: 'ابن بنت أخته', name: 'ابن بنت أخته' },
  { key: 58, id: 58, value: 'جده', name: 'جده' },
  { key: 59, id: 59, value: 'أخته لأمه', name: 'أخته لأمه' },
  { key: 60, id: 60, value: 'ابن ابن أخوه الشقيق', name: 'ابن ابن أخوه الشقيق' },
  { key: 62, id: 62, value: 'أخيه لأبيه', name: 'أخيه لأبيه' },
  { key: 63, id: 63, value: 'ابنة خالته', name: 'ابنة خالته' },
  { key: 64, id: 64, value: 'بنت عمه الشقيق', name: 'بنت عمه الشقيق' },
  { key: 65, id: 65, value: 'زوجة ابنه', name: 'زوجة ابنه' },
  { key: 66, id: 66, value: 'ابنة عمته', name: 'ابنة عمته' },
  { key: 67, id: 67, value: 'بنت بنت عمه', name: 'بنت بنت عمه' },
  { key: 69, id: 69, value: 'بنت ابن عمه', name: 'بنت ابن عمه' },
  { key: 70, id: 70, value: 'أم زوجته', name: 'أم زوجته' },
  { key: 71, id: 71, value: 'بنت ابن عم أمه', name: 'بنت ابن عم أمه' },
  { key: 72, id: 72, value: 'ابنة خالة أمه', name: 'ابنة خالة أمه' },
  { key: 73, id: 73, value: 'ابنة عمه', name: 'ابنة عمه' },
  { key: 74, id: 74, value: 'زوج أمه', name: 'زوج أمه' },
  { key: 75, id: 75, value: 'جد أمه', name: 'جد أمه' },
  { key: 76, id: 76, value: 'أخيه من الرضاعة', name: 'أخيه من الرضاعة' },
  { key: 77, id: 77, value: 'أخته من الرضاعة', name: 'أخته من الرضاعة' },
  { key: 78, id: 78, value: 'زوجته الحامل', name: 'زوجته الحامل' },
  { key: 79, id: 79, value: 'زوجته السابقة', name: 'زوجته السابقة' },
  { key: 80, id: 80, value: 'ابن بنت أخيه الشقيق', name: 'ابن بنت أخيه الشقيق' },
  { key: 81, id: 81, value: 'ابن عم أبيه', name: 'ابن عم أبيه' },
  { key: 82, id: 82, value: 'عم أبيه', name: 'عم أبيه' },
  { key: 84, id: 84, value: 'ابن ابن خاله', name: 'ابن ابن خاله' },
  { key: 85, id: 85, value: 'ابنة أخيه لأب', name: 'ابنة أخيه لأب' },
  { key: 86, id: 86, value: 'وصيه في النكاح', name: 'وصيه في النكاح' },
  { key: 87, id: 87, value: 'ابن ابن عم الأب لأب', name: 'ابن ابن عم الأب لأب' },
  { key: 88, id: 88, value: 'ابن ابن عم الأب الشقيق', name: 'ابن ابن عم الأب الشقيق' },
];

function normalizeHeirsData(heirsData) {
  if (!heirsData || !Array.isArray(heirsData)) return;
  heirsData.forEach((heir) => {
    // Skip if already a full object (dropdown-compatible)
    if (heir.deceasedRelationship && typeof heir.deceasedRelationship === 'object') {
      if (!heir.deceasedRelationshipName) {
        heir.deceasedRelationshipName = heir.deceasedRelationship.name || heir.deceasedRelationship.value;
      }
      return;
    }
    // Handle old lowercase casing: deceasedrelationship -> deceasedRelationship
    if (heir.deceasedrelationship != null && heir.deceasedRelationship == null) {
      heir.deceasedRelationship = heir.deceasedrelationship;
    }
    // Convert string values to matching data source entry
    if (heir.deceasedRelationship != null && typeof heir.deceasedRelationship === 'string') {
      const val = heir.deceasedRelationship;
      // If the string is a numeric id (e.g. "7" from JSON serialization), match by id
      const numVal = Number(val);
      const match = (!isNaN(numVal) && String(numVal) === val.trim())
        ? RELATIONSHIP_DATA_SOURCE.find(item => item.id === numVal)
        : RELATIONSHIP_DATA_SOURCE.find(item => item.name === val || item.value === val);
      if (match) {
        heir.deceasedRelationship = { ...match };
        heir.deceasedRelationshipName = match.name;
      } else {
        heir.deceasedRelationshipName = heir.deceasedRelationship;
        heir.deceasedRelationship = null;
      }
      return;
    }
    // Convert numeric id to full item object for dropdown pre-selection
    // (v-autocomplete uses return-object=true, needs full object to match)
    if (heir.deceasedRelationship != null && typeof heir.deceasedRelationship === 'number') {
      const match = RELATIONSHIP_DATA_SOURCE.find(item => item.id === heir.deceasedRelationship);
      if (match) {
        heir.deceasedRelationshipName = heir.deceasedRelationshipName || match.name;
        heir.deceasedRelationship = { ...match };
      }
    }
    // Fallback: relationship is null but name is a numeric id (e.g. resolveRelationship missed it)
    if (heir.deceasedRelationship == null && heir.deceasedRelationshipName) {
      const numVal = Number(heir.deceasedRelationshipName);
      if (!isNaN(numVal) && String(numVal) === String(heir.deceasedRelationshipName).trim()) {
        const match = RELATIONSHIP_DATA_SOURCE.find(item => item.id === numVal);
        if (match) {
          heir.deceasedRelationship = { ...match };
          heir.deceasedRelationshipName = match.name;
        }
      }
    }
  });
}

export default {
  components: { Grids },
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  watch: {
    'formModel.heirsData': {
      immediate: true,
      handler(data) {
        normalizeHeirsData(data);
      },
    },
  },
  data() {
    return {
      label: 'بيانات الورثة',
      dataGridConfig: {
        headers: [
          {
            value: 'heirName',
            name: 'heirName',
            text: 'الاسم',
            header: 'الاسم',
            order: 1,
          },
          {
            value: 'idNumber',
            name: 'idNumber',
            text: 'رقم الهوية',
            header: 'رقم الهوية',
            order: 2,
          },
          {
            value: 'deceasedRelationshipName',
            name: 'deceasedRelationshipName',
            text: 'صلة القرابة بالمتوفى',
            header: 'صلة القرابة بالمتوفى',
            order: 3,
          },
        ],
        filters: [],
        actions: [
          {
            actionType: 6,
            actionName: 'إضافة',
          },
          {
            actionType: 7,
            actionName: 'تعديل',
          },
          {
            actionType: 8,
            actionName: 'حذف',
          },
          {
            actionType: 9,
            actionName: 'معاينة',
          },
        ],
        formLabel: 'الورثة',
        fields: prepareDynamicFormFieldsForAPI([
          {
            typeId: 11,
            name: 'section',
            label: 'بيانات الوريث',
            sortIndex: 1,
            properties: {
              dataGridConfig: null,
              dateConfig: {},
            },
            fields: [
              {
                typeId: 7,
                name: 'heirGender',
                label: 'النوع',
                columnSize: 12,
                sortIndex: 1,
                properties: {
                  validations: { required: 'true' },
                  externalDataSource: {},
                  textName: 'heirGenderName',
                  pickListId: 7,
                  dataGridConfig: null,
                  dataSource: [
                    {
                      key: 1,
                      id: 1,
                      value: 'ذكر',
                      name: 'ذكر',
                    },
                    {
                      key: 2,
                      id: 2,
                      value: 'أنثى',
                      name: 'أنثى',
                    },
                  ],
                  dateConfig: {},
                },
                description: 'النوع',
                fields: [],
              },
              {
                typeId: 4,
                name: 'deceasedRelationship',
                label: 'صلة القرابة بالمتوفى',
                columnSize: 4,
                sortIndex: 2,
                properties: {
                  validations: { required: 'true' },
                  externalDataSource: {},
                  textName: 'deceasedRelationshipName',
                  pickListId: 9955,
                  dataGridConfig: null,
                  dateConfig: {},
                  dataSource: RELATIONSHIP_DATA_SOURCE,
                },
                description: 'صلة القرابة بالمتوفى',
                fields: [],
              },
              {
                typeId: 1,
                name: 'heirName',
                label: 'الاسم',
                columnSize: 4,
                sortIndex: 3,
                properties: {
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'الاسم',
                fields: [],
              },
              {
                typeId: 1,
                name: 'idNumber',
                label: 'رقم الهوية',
                columnSize: 4,
                sortIndex: 4,
                properties: {
                  validations: {
                    required: 'true',
                    numeric: 'true',
                    isValid:
                      '\'رقم الهوية يجب أن يكون 10 أرقام\', obj.idNumber.length == 10',
                  },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'رقم الهوية',
                fields: [],
              },
              {
                typeId: 3,
                name: 'birthDate',
                label: 'تاريـخ الميلاد',
                columnSize: 4,
                sortIndex: 5,
                properties: {
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'تاريـخ الميلاد',
                fields: [],
              },
              {
                typeId: 4,
                name: 'heirCondition',
                label: 'بيان حال الوارث',
                columnSize: 4,
                sortIndex: 6,
                properties: {
                  validations: { required: 'true' },
                  externalDataSource: {},
                  textName: 'heirConditionName',
                  pickListId: 73,
                  dataGridConfig: null,
                  dataSource: [
                    {
                      key: 1,
                      id: 1,
                      value: 'راشد',
                      name: 'راشد',
                    },
                    {
                      key: 2,
                      id: 2,
                      value: ' قاصر سناً',
                      name: ' قاصر سناً',
                    },
                    {
                      key: 3,
                      id: 3,
                      value: 'قاصر عقلاً',
                      name: 'قاصر عقلاً',
                    },
                    {
                      key: 4,
                      id: 4,
                      value: 'متوفى',
                      name: 'متوفى',
                    },
                  ],
                  dateConfig: {},
                  if: '!obj.heirGender || obj.heirGender==1',
                  disabledIf: '!obj.heirGender',
                },
                description: 'بيان حال الوارث',
                fields: [],
              },
              {
                typeId: 4,
                name: 'heirCondition',
                label: 'بيان حال الوارث',
                columnSize: 4,
                sortIndex: 7,
                properties: {
                  validations: { required: 'true' },
                  dateConfig: {},
                  externalDataSource: {},
                  textName: 'heirConditionName',
                  pickListId: 82,
                  if: 'obj.heirGender==2',
                  dataGridConfig: null,
                  dataSource: [
                    {
                      key: 1,
                      id: 1,
                      value: 'راشدة',
                      name: 'راشدة',
                    },
                    {
                      key: 2,
                      id: 2,
                      value: 'قاصرة سنًا',
                      name: 'قاصرة سنًا',
                    },
                    {
                      key: 3,
                      id: 3,
                      value: 'قاصرة عقلًا',
                      name: 'قاصرة عقلًا',
                    },
                    {
                      key: 4,
                      id: 4,
                      value: 'متوفية',
                      name: 'متوفية',
                    },
                    {
                      key: 5,
                      id: 5,
                      value: 'حامل',
                      name: 'حامل',
                    },
                  ],
                },
                description: 'بيان حال الوارث',
                fields: [],
              },
              {
                typeId: 3,
                name: 'heirdeathDate',
                label: 'تاريخ وفاة الوارث',
                columnSize: 4,
                sortIndex: 8,
                properties: {
                  validations: {},
                  dateConfig: {},
                  disabledIf: '',
                  show: 'obj.heirCondition==4',
                  dataGridConfig: null,
                },
                description: 'تاريخ وفاة الوارث',
                fields: [],
              },
            ],
          },
          {
            typeId: 11,
            name: 'section',
            label: 'بيانات أبناء الورثة',
            sortIndex: 2,
            properties: {
              dataGridConfig: null,
              dateConfig: {},
            },
            fields: [
              {
                typeId: 1,
                name: 'issuerSubGrid',
                label: 'جهة إصدار صك حصر الورثة',
                columnSize: 4,
                sortIndex: 1,
                properties: {
                  show: 'obj.heirCondition==4',
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'جهة إصدار صك حصر الورثة',
                fields: [],
              },
              {
                typeId: 1,
                name: 'instrumentNumberSubGrid',
                label: 'رقم الصك',
                columnSize: 4,
                sortIndex: 2,
                properties: {
                  show: 'obj.heirCondition==4',
                  validations: {
                    required: 'true',
                    numeric: 'true',
                    isValid:
                      '\'رقم الصك يجب أن يكون 14 رقم كحد أقصى\', obj.instrumentNumberSubGrid.length <= 14',
                  },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'رقم الصك',
                fields: [],
              },
              {
                typeId: 3,
                name: 'dateSubGrid',
                label: 'تاريخ الصـك',
                columnSize: 4,
                sortIndex: 3,
                properties: {
                  show: 'obj.heirCondition==4',
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'تاريخ الصـك',
                fields: [],
              },
              {
                typeId: 22,
                name: 'heirsSubGrid',
                label: 'بيانات الورثة',
                columnSize: 12,
                sortIndex: 4,
                properties: {
                  if: 'obj.heirCondition==4',
                  validations: {},
                  gridId: 41,
                  dataGridConfig: {
                    headers: [
                      {
                        value: 'heirNameSubGrid',
                        name: 'heirNameSubGrid',
                        text: 'الاسم',
                        header: 'الاسم',
                        order: 1,
                      },
                      {
                        value: 'idNumberSubGrid',
                        name: 'idNumberSubGrid',
                        text: 'رقم الهوية',
                        header: 'رقم الهوية',
                        order: 2,
                      },
                      {
                        value: 'deceasedRelationshipSubGridName',
                        name: 'deceasedRelationshipSubGridName',
                        text: 'صلة القرابة بالمتوفى',
                        header: 'صلة القرابة بالمتوفى',
                        order: 3,
                      },
                    ],
                    filters: [],
                    actions: [
                      {
                        actionType: 6,
                        actionName: 'إضافة',
                      },
                      {
                        actionType: 7,
                        actionName: 'تعديل',
                      },
                      {
                        actionType: 8,
                        actionName: 'حذف',
                      },
                      {
                        actionType: 9,
                        actionName: 'معاينة',
                      },
                    ],
                    formLabel: 'بيانات ورثة المتوفى الوارث',
                    fields: [
                      {
                        typeId: 7,
                        name: 'heirGenderSubGrid',
                        label: 'النوع',
                        columnSize: 12,
                        sortIndex: 1,
                        properties:
                        {
                          validations: { 'required': 'true' },
                          externalDataSource: {},
                          textName: 'heirGenderSubGridName',
                          dataGridConfig: null,
                          dataSource: [
                            {
                              key: 1,
                              id: 1,
                              value: 'ذكر',
                              name: 'ذكر',
                            },
                            {
                              key: 2,
                              id: 2,
                              value: 'أنثى',
                              name: 'أنثى',
                            },
                          ],
                          dateConfig: {},
                        }
                        ,
                        description: 'النوع',
                        fields: [],
                      },
                      {
                        typeId: 4,
                        name: 'deceasedRelationshipSubGrid',
                        label: 'صلة القرابة بالمتوفى',
                        columnSize: 4,
                        sortIndex: 2,
                        properties:
                        {
                          validations: { 'required': 'true' },
                          externalDataSource: {},
                          textName: 'deceasedRelationshipSubGridName',
                          pickListId: 9955,
                          dataGridConfig: null,
                          dateConfig: {},
                          dataSource: RELATIONSHIP_DATA_SOURCE,
                        },
                        description: 'صلة القرابة بالمتوفى',
                        fields: [],
                      },
                      {
                        typeId: 1,
                        name: 'heirNameSubGrid',
                        label: 'الاسم',
                        columnSize: 4,
                        sortIndex: 3,
                        properties:
                        {
                          validations: { 'required': 'true' },
                          dataGridConfig: null,
                          dateConfig: {},
                        }
                        ,
                        description: 'الاسم',
                        fields: [],
                      },
                      {
                        typeId: 1,
                        name: 'idNumberSubGrid',
                        label: 'رقم الهوية',
                        columnSize: 4,
                        sortIndex: 4,
                        properties:
                        {
                          validations: {
                            required: 'true',
                            numeric: 'true',
                            isValid: '\'رقم الهوية يجب أن يكون 10 أرقام\', obj.idNumberSubGrid.length == 10',
                          },
                          dataGridConfig: null,
                          dateConfig: {},
                        }
                        ,
                        description: 'رقم الهوية',
                        fields: [],
                      },
                      {

                        typeId: 3,
                        name: 'birthDateSubGrid',
                        label: 'تاريخ الميلاد',
                        columnSize: 4,
                        sortIndex: 5,
                        properties:
                        {
                          validations: { required: 'true' },
                          dataGridConfig: null,
                          dateConfig: {},
                        }
                        ,
                        description: 'تاريخ الميلاد',
                        fields: [],
                      },
                      {

                        typeId: 4,
                        name: 'heirConditionSubGrid',
                        label: 'بيان حال الوارث',
                        columnSize: 4,
                        sortIndex: 6,
                        properties:
                        {
                          validations: { required: 'true' },
                          externalDataSource: {},
                          textName: 'heirConditionSubGridName',
                          dataGridConfig: null,
                          dataSource: [
                            {
                              key: 1,
                              id: 1,
                              value: 'راشد',
                              name: 'راشد',
                            },
                            {
                              key: 2,
                              id: 2,
                              value: ' قاصر سناً',
                              name: ' قاصر سناً',
                            },
                            {
                              key: 3,
                              id: 3,
                              value: 'قاصر عقلاً',
                              name: 'قاصر عقلاً',
                            },
                            {
                              key: 4,
                              id: 4,
                              value: 'متوفى',
                              name: 'متوفى',
                            },
                          ],
                          dateConfig: {},
                          if: '!obj.heirGenderSubGrid || obj.heirGenderSubGrid == 1',
                          disabledIf: '!obj.heirGenderSubGrid',
                        }
                        ,
                        description: 'بيان حال الوارث',
                        fields: [],
                      },
                      {
                        typeId: 4,
                        name: 'heirConditionSubGrid',
                        label: 'بيان حال الوارث',
                        columnSize: 4,
                        sortIndex: 7,
                        properties:
                        {
                          validations: { required: 'true' },
                          dateConfig: {},
                          externalDataSource: {},
                          textName: 'heirConditionSubGridName',
                          if: 'obj.heirGenderSubGrid==2',
                          dataGridConfig: null,
                          dataSource: [
                            {
                              key: 1,
                              id: 1,
                              value: 'راشدة',
                              name: 'راشدة',
                            },
                            {
                              key: 2,
                              id: 2,
                              value: 'قاصرة سنًا',
                              name: 'قاصرة سنًا',
                            },
                            {
                              key: 3,
                              id: 3,
                              value: 'قاصرة عقلًا',
                              name: 'قاصرة عقلًا',
                            },
                            {
                              key: 4,
                              id: 4,
                              value: 'متوفية',
                              name: 'متوفية',
                            },
                            {
                              key: 5,
                              id: 5,
                              value: 'حامل',
                              name: 'حامل',
                            },
                          ],
                        }
                        ,
                        description: 'بيان حال الوارث',
                        fields: [],
                      },
                    ],
                  },
                  dateConfig: {},
                },
                description: 'بيانات الورثة',
                fields: [],
              },
            ],
          },
        ]),
      },
    };
  },
};
</script>
